fragment AccordionFragment on accordion_Entry {
  typeHandle

  # Content
  heading
  backgroundGreen
  useShopifyData
  accordions {
    ... on accordionItem_Entry {
      id
      accordionTitle
      body
    }
  }

  # Layout
  accordionLayout

  # Schema
  useSchemaOrg
}
